<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      Question Preview
    </div>

    <div class="bg-info p-1">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-sm btn-primary" (click)="BackUrl()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
    </div>
    <div class="card-body" style="margin-left:50px !important">
      <ng-container *ngIf="questionPreviewData">
        <div class="container-fluid" *ngIf="question">
          <div *ngIf="question.type=='Matrix'" class="col-md-12 row">
            <label class="form-control-label col-md-12 row font-weight-bold">
              {{question.text}}
            </label>
            <table id="0_{{question.qid}}" class="table table-responsive table-striped table-align-middle table-sm table-bordered text-center col-md-12 row">

              <thead>
                {{loadHeaders(question.matrix.headerInnerHTML,0,question)}}
              </thead>
              <tbody>
                <tr *ngFor="let row of question.matrix.rowdataFields">
                  <td *ngIf="!question.matrix.hideRowHeader" class="cust-text-wrap" [style.min-width]="question.width==''?'60px':question.width"><label class='form-control-label m-0 float-left text-left'>{{row.rowText}}</label></td>
                  <td *ngFor="let column of question.matrix.columnFields" class="cust-text-wrap" style="min-width:60Px!important" data-original-title="999" data-container="body" data-toggle="tooltip" data-placement="top" title="Column Header : {{column.columnHeaderText}}">
                    <ng-container [ngSwitch]="column.controlType">
                      <label *ngSwitchCase="'Label'" class="form-control-label m-0 float-left text-left">{{setValue(row,column)}}</label>
                      <input *ngSwitchCase="'Text'" type="text" class="form-control-sm" [value]="setValue(row,column)" data-container="body" data-toggle="tooltip" data-placement="top" title="Column Header : {{column.columnHeaderText}}" />
                      <select *ngSwitchCase="'PickList'">
                        <option value="" disabled selected>Select an option</option>
                        <option [ngValue]="data.value" *ngFor="let data of column.dataSource">{{data.text}}</option>
                      </select>
                      <input *ngSwitchCase="'CheckBox'" type="checkbox" [checked]="getChecked(row,column)" />
                      <textarea *ngSwitchCase="'TextArea'" class="form-control-sm col-md-12" rows="500" style="height:50px;" placeholder="type here..."></textarea>
                      <input *ngSwitchCase="'RadioButton'" type="radio" />
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="question.type=='ConstantSum'" class="col-md-12">
            <p class="fw-bold mb-3">
              {{question.text}}
            </p>

            <fieldset class="scheduler-border position-relative mt-4 mb-5" style="border:1px solid #f2f2f2; padding:10px;">
              <legend class="mng-legend scheduler-border form-control-label-small font-weight-bold p-1" style="width:auto;">Total Spend</legend>
              <div id="1_{{question.qid}}" class="col-md-12 row">
                <div class="col-md-12">
                  <table>
                    <tbody>
                      <tr>
                        <td class="cust-text-wrap" [style.min-width]="question.width==''?'60px':question.width">
                          <label class="form-control-label-small m-0 float-left text-left">Capex vs. Opex</label>
                        </td>

                        <td class="cust-text-wrap">
                          <ng-container>
                            <input type="text" class="form-control-sm" value="{{question.constantSum.categoryValue}}" style="width:100px;" readonly="readonly" />
                          </ng-container>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </fieldset>
            <br />
            <fieldset class="scheduler-border position-relative mt-1" style="border:1px solid #f2f2f2; padding:10px;">
              <legend class="mng-legend scheduler-border form-control-label-small  font-weight-bold p-1" style="width:auto;">Breakdown</legend>
              <div id="0_{{question.qid}}" class="col-md-12 row">
                <div class="col-md-12">
                  <table cellpadding="0" cellspacing="10" style="padding-bottom:5px !important;">
                    <tbody>
                      <tr *ngFor="let row of question.constantSum.rowdataFields">
                        <td *ngIf="!question.constantSum.hideRowHeader" class="cust-text-wrap" [style.min-width]="question.width==''?'60px':question.width"><label class='form-control-label-small m-0 float-left text-left'>{{row.rowText}}</label></td>
                        <td *ngFor="let column of question.constantSum.columnFields" class="cust-text-wrap">
                          <ng-container [ngSwitch]="column.controlType">
                            <label *ngSwitchCase="'Label'" class="form-control-label-small m-0 float-left text-left">{{setValue(row,column)}}</label>
                            <input *ngSwitchCase="'Text'" type="text" placeholder="Input Data" (blur)="findTotal(question.constantSum.categoryValue, $event)" name="subCategoryQuantity" style="width:100px; margin-left:10px;" class="col-md-10 form-control-sm" [value]="setValue(row,column)" data-toggle="tooltip" data-placement="top" [title]="setValue(row,column)" />
                            <textarea *ngSwitchCase="'TextArea'" class="form-control-sm col-md-12" rows="" style="width:200px; height:40px" placeholder="Notes/Comments..."></textarea>
                          </ng-container>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>

            </fieldset>


          </div>

          <div class="form-group" *ngIf="question.type=='Slider'">
            <label class="form-control-label col-md-12 row font-weight-bold">
              {{question.text}}
            </label>

            <div>
              <!--<form [formGroup]="sliderForm" #f="ngForm">-->
              <div class="card-body">
                <div class="row">
                  <div class="col-md-10">
                    <ngx-slider [value]="question.defaultValue"
                                [options]="soptions"
                                (valueChange)="question.defaultValue = $event">
                    </ngx-slider>
                  </div>
                </div>
              </div>
              <!--</form>-->
            </div>

          </div>
          <div *ngIf="question.type=='MultipleResponse'">
            <label class="form-control-label col-md-12 row mb-2">
              {{question.text}}
            </label>
            <div class="col-md-12 row position-relative mb-2" *ngFor="let option of question.multipleResponse;">
              <label popoverPlacement="top left"
                     class="form-control-label mx-3 ">
                <input type="radio" name="grpRespo_{{question.id}}" value="{{option.value}}" />
                {{option.name}}  <img [src]="option.optionImage" accept="image/png," height="20" width="20" class="pb-1" *ngIf="option.optionImage" />
              </label>
            </div>
          </div>
          <div *ngIf="question.type=='MultipleChoice'">
            <label class="form-control-label col-md-12 row mb-2">
              <strong>{{question.text}}</strong>
            </label>
            <div class="col-md-12 row mb-2" *ngFor="let option of question.multipleChoice;">
              <label class="form-control-label mx-3">
                <input type="checkbox" name="grpRespo_{{question.qid}}" value="{{option.value}}" />
                <span [popover]="option.hoverText"
                      popoverPlacement="top">
                  {{option.name}}
                  <img [src]="option.optionImage" accept="image/png," height="20" width="20" class="pb-1" *ngIf="option.optionImage" />
                </span>
              </label>
            </div>
          </div>

          <div *ngIf="question.type=='RankingSort'">
            <label class="form-control-label col-md-12 row font-weight-bold">
              {{question.text}}
            </label>
            <div class="col-md-12 row" *ngFor="let option of question.multipleChoice;">
              <label class="form-control-label mx-3">
                <input type="checkbox" name="grpChoice_{{question.id}}" value="{{option.value}}" />
                {{option.name}}
              </label>
            </div>

            <div class="form-group">
              <ag-grid-angular style="width: 100%; height: 500px;"
                               class="ag-theme-balham"
                               [headerHeight]="0"
                               [enableSorting]="true"
                               [rowData]="question.rankingSort"
                               [rowDragManaged]="true"
                               (gridReady)="onRankingSortGridReady($event)"
                               [columnDefs]="colDefsRankingSort"
                               [enableFilter]="true"
                               (rowSelected)="onRankingRowSelected($event)"
                               (rowDragEnd)="onDragEnd($event)"
                               rowSelection="multiple">
              </ag-grid-angular>
            </div>

          </div>

          <div class="form-group" *ngIf="question.type=='TextInput'">
            <label class="form-control-label col-md-12 row font-weight-bold">
              {{question.text}}
            </label>
            <div class="col-md-12 row">
              <input [style.width]="question.width==''?'300px':question.width" type="text" [attr.maxlength]="question.maxCharacterLength=='' ? 1500 : question.maxCharacterLength" class="form-control-sm " placeholder="type here..." (keyup)="onKeypressEvent($event)" />

            </div>
            <div *ngIf="isMaxCharacterExceed" style="color: red;font-size: 11px;">Reached Max Length</div>
          </div>

          <div class="form-group" *ngIf="question.type=='DateTime'">
            <label class="form-control-label col-md-12 row font-weight-bold">
              {{question.text}}
            </label>
            <div class="col-md-3 row">
              <input bsDatepicker
                     [bsConfig]="bsConfig"
                     [(ngModel)]="newVar"
                     type="text"
                     class="form-control form-control-sm"
                     placeholder="Choose Date"
                     (keyup)="onKeypressEvent($event)" />
            </div>
          </div>

          <div *ngIf="question.type=='Description'">
            <label class="form-control-label col-md-12 row">
              {{question.text}}
            </label>

            <div class="col-md-12 row">
              <textarea class="form-control-sm col-md-12" style="height:50px" rows="500" [attr.maxlength]="question.maxCharacterLength=='' ? 1500 : question.maxCharacterLength" placeholder="type here..." (keyup)="onKeypressEvent($event)"></textarea>
            </div>
            <div *ngIf="isMaxCharacterExceed" style="color: red;font-size:11px;">Reached Max Length</div>
          </div>
          <div *ngIf="question.type=='Picklist'">
            <label class="form-control-label col-md-12 row font-weight-bold">
              {{question.text}}
            </label>
            <div class="col-md-12 row">
              <select [style.width]="question.width==''?'200px':question.width" class="form-control-sm">
                <!--<option disable hidden value="">Select an option</option>-->
                <option style="display:none"></option>
                <option *ngFor="let option of question.pickList;" value="{{option.value}}">{{option.text}}</option>
              </select>
            </div>
          </div>
        </div>

      </ng-container>
    </div>
  </div>
</div>



